export const allowedMaxCount = (n: number, maxCount: number) => n <= maxCountexport const allowedMaxCount = (n: number, maxCount: number) => n <= maxCount